import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 1. TỪ ĐIỂN MẶC ĐỊNH LÀ TIẾNG ANH
const resources = {
    EN: {
        translation: {
            // ── LeatherPicker / Home ─────────────────────────────
            "luxury_preview": "LUXURY PREVIEW",
            "width": "WIDTH",
            "short": "SHORT",
            "long": "LONG",
            "btn_confirm_pattern": "CONFIRM PATTERN",
            "btn_capturing": "CAPTURING...",
            "btn_design_finalized": "DESIGN FINALIZED",
            "btn_confirmed": "CONFIRMED",
            "msg_cant_select": "CAN'T SELECT",
            "leather_price": "Leather Price:",
            "defective_area": "This area is defective and not allowed!",
            "used_area": "This area of leather has been used!",
            "ZONE COLLIDES WITH RESTRICTED AREA": "Zone collides with restricted/defect area!",
            "ZONE OVERLAPS WITH USED AREA": "Zone overlaps with used/purchased area!",
            "ZONE IS OUT OF BOUNDS": "Zone is out of leather hide bounds!",
            "SHORT STRAP OVERLAP": "Short strap overlaps with restricted or used area!",
            "LONG STRAP OVERLAP": "Long strap overlaps with restricted or used area!",
            "STRAPS OVERLAP": "Short strap and Long strap overlap with each other!",
            "OVERLAP DETECTED": "Strap overlaps with restricted or used area!",
            "free_move_locked": "MAX 1 CUT ALLOWED",
            "all_used": "ALL AREAS USED",
            "leather_type": "Leather Type",
            "sold_out": "SOLD OUT",
            "free_move": "Free Move",
            "pre_selected": "Pre-selected",
            "not_available": "NOT AVAILABLE",
            "loading_texture": "LOADING TEXTURE...",
            "in_cart": "IN CART",
            "sold": "SOLD",
            "not_allowed": "NOT ALLOWED",
            "no_leather_title": "NO LEATHER AVAILABLE",
            "no_leather_desc": "Currently, there are no leather hides available for custom styling. Please check back later.",
            "btn_reload": "RELOAD PAGE",

            // ── ConfigSidebar ────────────────────────────────────
            "lug_width_label": "Lug Width",
            "short_length_label": "Short Length",
            "long_length_label": "Long Length",
            "range_error": "Value must be between",
            "bespoke_options": "BESPOKE OPTIONS",

            // ── ResultModal ──────────────────────────────────────
            "design_finalized_title": "Design Finalized",
            "design_finalized_desc": "Your bespoke strap has been successfully configured.",
            "leather": "Leather",
            "premium_leather": "Premium Leather",
            "lug_width": "Lug Width",
            "short_length": "Short Length",
            "long_length": "Long Length",
            "total_price": "Total Price",
            "btn_edit": "Edit",
            "btn_add_to_cart": "Add to Cart",

            // ── StrapOptions (sidebar + result modal) ────────────
            "size_configuration": "Size",
            "additional_options": "Additional Options",
            "select_option": "Select",
            // ── Settings menu ─────────────────────────────────────
            "my_cart": "My Cart",
            "go_home": "Home",
            "language": "Language"
        }
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "EN",
        fallbackLng: "EN",
        interpolation: { escapeValue: false },
        // DÒNG THẦN THÁNH NÀY SẼ CỨU LỖI CRASH GIAO DIỆN:
        react: { useSuspense: false }
    });

export default i18n;
